import { LoginService } from "./login.service";
import { Router } from "@angular/router";
var LoginComponent = (function () {
    function LoginComponent(loginService, router) {
        this.loginService = loginService;
        this.router = router;
    }
    LoginComponent.prototype.ngOnInit = function () {
        this.alert = JSON.parse(sessionStorage.getItem("alert"));
        this.logout();
    };
    LoginComponent.prototype.onSubmit = function (formLogin) {
        var _this = this;
        this.loginService.sendPost(formLogin.value)
            .then(function (res) {
            if (res.status === 0) {
                _this.alert = res.message;
                console.log(_this.alert);
            }
            else {
                _this.alert = '';
                sessionStorage.setItem('jwt', JSON.stringify(res.data.accessToken));
                sessionStorage.setItem('currentUser', JSON.stringify(res.data.profile));
                _this.router.navigate(['']);
            }
        })
            .catch(function (err) { return console.log(err); });
    };
    LoginComponent.prototype.logout = function () {
        // remove user from local storage to log user out
        sessionStorage.removeItem('currentUser');
        sessionStorage.removeItem('jwt');
        sessionStorage.removeItem('alert');
    };
    return LoginComponent;
}());
export { LoginComponent };



// WEBPACK FOOTER //
// /build/client-cms/src/app/login/login.component.ts.pre-build-optimizer.js